import React, {useEffect, useState} from "react";
import IconHeading from "../../../Icons/IconHeading";
import LocationSearchField from "../../LocationSearch/LocationSearchField";
import ParticipantInput from "../../ParticipantSelector/ParticipantInput";
import {INBOUND, ONE_WAY_TRIP, OUTWARD, RETURN_TRIP} from "../../consts/bookingConsts";
import TimeField from "../../TimeField/TimeField";
import {bookingMinDate} from "../../days/days";


const TripSection = (props) => {

  const {
    tripType,
    bookingType,
    startAddress,
    endAddress,
    pax,
    date,
    outDate,
    time,
    paxError,

    airlines,
    airport,
    airline,
    flightNumber,
    flightTime,
    terminal,
    noFlight,

    setStartLat,
    setStartLng,
    setStartAddress,
    setEndLat,
    setEndLng,
    setEndAddress,
    setPax,
    setDate,
    setTime,
    showTime,
    setBookingType,
    setAirport,
    setTerminal,

    setAirline,
    setFlightNumber,
    setFlightTime,
    setNoFlight,

    isUnavailable,
    showTerminal

  } = props;

  const [inLAirport, setInLAirport] = useState(false);
  const [inLLAirport, setInLLAirport] = useState(false);
  const [initAirport, setInitAirport] = useState(false);

  useEffect(() => {
    setInitAirport(showTerminal);
  }, [])


  return <>
    <div className="booking__trips booking__section">
      <div className="booking__title">
        <div className="booking__headIcon">
          <IconHeading />
        </div>
        <h3>{tripType === OUTWARD ? 'Trip Details' : 'Return Trip Details'}</h3>
      </div>
      <div className="booking__trip__inputs">
        <div className="booking__trip__input input--wide">
          <label>Pick-up address</label>
          <LocationSearchField
            address={startAddress}
            selectLat={(lat) => {
              setStartLat(lat);
            }}
            selectLng={(lng) => {
              setStartLng(lng);
            }}
            selectAddress={(address) => {
              setStartAddress(address);
            }}
            selectIsAirport={(is) => {
              setInLAirport(is);
              setInitAirport(false);
              if (setAirport) {
                setAirport(is || inLLAirport);
              }
            }}
          />
        </div>
        <div className="booking__trip__input input--wide">
          <label>Drop-off address</label>
          <LocationSearchField
            address={endAddress}
            selectLat={(lat) => {
              setEndLat(lat);
            }}
            selectLng={(lng) => {
              setEndLng(lng);
            }}
            selectAddress={(address) => {
              setEndAddress(address);
            }}
            selectIsAirport={(is) => {
              setInLLAirport(is);
              setInitAirport(false);
              if (setAirport) {
                setAirport(is || inLAirport);
              }
            }}
          />
        </div>
        <div className="booking__trip__input input--sm">
          <label>Passengers</label>
          <ParticipantInput
            onChange={(val) => {
              setPax(val);
            }}
            types={pax}
            error={paxError}
          />
        </div>
      </div>
      <div className="booking__trip__inputs">
        <div className="booking__trip__input input--md date-picker">
          <label>Date of Travel</label>
          <input
            name={`${tripType}_date`}
            aria-labelledby="date"
            type="date"
            value={date}
            min={bookingMinDate(outDate)}
            required={true}
            onChange={(e) => {
              setDate(e.target.value)
            }}
          ></input>
        </div>

        {showTime && <div className="booking__trip__input input--md time-picker">
          <label>Pick-up time</label>
          <TimeField
            name={`${tripType}_time`}
            type="time"
            value={time}
            required={true}
            onChange={(val) => {
               setTime(val)
            }}
          />
        </div>}

        {(inLLAirport || inLAirport || initAirport) && <div className="booking__trip__input input--md ">
          <label>Terminal</label>
          <select
            required={true}
            // required={!noFlight}
            // disabled={noFlight}
            value={terminal}
            name={`${tripType}_terminal`}
            onChange={(e) => {
              setTerminal(e.target.value)
            }}
          >
            <option value={''}>Select</option>
            <option value={'Domestic'}>Domestic</option>
            <option value={'International'}>International</option>
            <option value={'N/A'}>Not Applicable</option>
          </select>
        </div>}

        <div className="booking__trip__input input--sm">
          {bookingType === ONE_WAY_TRIP && <button
            onClick={() => {
              setBookingType(RETURN_TRIP)
            }}
            className="btn btn--lg btn--stroke">ADD RETURN TRIP</button>}
          {(bookingType === RETURN_TRIP && tripType === INBOUND) && <button
            onClick={() => {
              setBookingType(ONE_WAY_TRIP)
            }}
            className="btn btn--lg btn--stroke">REMOVE RETURN TRIP</button>}
        </div>
      </div>
    </div>

    {(airport && !isUnavailable) && <>
      <div className="booking__section">
        <div className="booking__departing">
          <div className="booking__title">
            <div className="booking__headIcon">
              <IconHeading />
            </div>
            <h3>
              Flight Information
            </h3>
          </div>
        </div>
        <div className="booking__departing__inputs booking__section__inputs">
          <div className="booking__section__input input--md">
            <label htmlFor="airlines">Airline</label>
            <select
              required={!noFlight}
              disabled={noFlight}
              value={airline}
              name={`${tripType}_airline`}
              id="airlines"
              onChange={(e) => {
                setAirline(e.target.value)
              }}
            >
              <option value={''}>Select</option>
              {airlines.map((a) => {
                return <option value={a.id} key={a.id}>{a.label}</option>
              })}
            </select>
          </div>
          <div className="booking__section__input input--md">
            <label>Flight number</label>
            <input
              required={!noFlight}
              aria-labelledby="flight"
              disabled={noFlight}
              value={flightNumber}
              name={`${tripType}_flight`}
              onChange={(e) => {
                setFlightNumber(e.target.value)
              }}
              type="text"></input>
          </div>
          <div className="time-picker booking__section__input input--md">
            <label>Flight time</label>
            <input
              aria-labelledby="flight"
              required={!noFlight}
              disabled={noFlight}
              value={flightTime}
              name={`${tripType}_flighttime`}
              onChange={(e) => {
                setFlightTime(e.target.value)
              }}
              type="time" />
          </div>
          {/*<div className="time-picker booking__section__input input--md">*/}
          {/*  <label>Terminal</label>*/}
          {/*  <select*/}
          {/*    required={!noFlight}*/}
          {/*    disabled={noFlight}*/}
          {/*    value={terminal}*/}
          {/*    name={`${tripType}_terminal`}*/}
          {/*    onChange={(e) => {*/}
          {/*      setTerminal(e.target.value)*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    <option value={'Domestic'}>Domestic</option>*/}
          {/*    <option value={'International'}>International</option>*/}
          {/*  </select>*/}
          {/*</div>*/}
          <div className="booking__section__input--full booking__section__checkbox input--md">
            <input
              checked={noFlight}
              type={'checkbox'}
              aria-labelledby="checked"
              id={`${tripType}_no_flight`}
              onChange={() => {
                setNoFlight(!noFlight);
              }}
            />
            <label htmlFor={`${tripType}_no_flight`}>No flight</label>
          </div>
        </div>
      </div>
    </>}


  </>
}

export default TripSection;
